import {useContext, useState} from "react";
import {useRouter} from "next/router";
import UserContext from "context/AuthContext";
import {Axios} from "api";
import {getCreatorRoute, getPostEditRoute, myPageRoute} from "common/const";
import {captureException, captureMessage} from "@sentry/nextjs";
import {customConfirm} from "common/utils";
import Modal from "components/Modal";
import classNames from "classnames";
import utilStyles from "styles/utils.module.scss";
import Loading from "components/Loading";
import styles from "components/modal/editPostModal.module.scss";
import Link from "next/link";
import PostListContext, {postListContextRef} from "context/PostListContext";
import useTranslation from "next-translate/useTranslation";

export const EditPostModal = (props) => {
    const {post, close, isOwner} = props;
    const {t} = useTranslation('components-modal-EditPostModal');
    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(true);

    const router = useRouter();
    const user = useContext(UserContext).user;


    const deletePost = async () => {
        try {
            setIsLoading(true);
            const res = await Axios.delete(`v1/palette/posts/${props.post.id}/`);
            if (res.status < 400) {
                if (router.pathname === '/palette/[pid]') {
                    if (user.code) {
                        router.replace({
                            pathname: getCreatorRoute(user.code),
                            query: {
                                tab: 'palette'
                            }
                        })
                    } else {
                        router.replace(myPageRoute);
                    }
                } else {
                    router.reload();
                }
                close();
            } else {
                alert(res.data.display_message || t('EditPostModal.deleteError'));
                captureMessage(JSON.stringify(res.data));
            }
        } catch (e) {
            alert(t('EditPostModal.deleteError'));
            captureException(e);
        } finally {
            setIsLoading(false);
        }
    };

    const handleReport = async () => {
        setIsLoading(true);
        await postListContextRef.current.reportPost(user, post.id);
        setIsLoading(false);
        close();
    };

    const onDeleteClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'EditPostModalDeleteClick'
        );
        setIsVisible(false);
        customConfirm(
            t('EditPostModal.deletePost'),
            t('EditPostModal.delete'),
            t('EditPostModal.cancel'),
            () => {
                setIsVisible(true);
                deletePost();
            },
            () => setIsVisible(true),
        );
    };

    const handleReportClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'EditPostModalAbuseReportClick'
        );
        setIsVisible(false);
        customConfirm(
            t('EditPostModal.reportPost'),
            t('EditPostModal.report'),
            t('EditPostModal.update'),
            () => {
                setIsVisible(true);
                handleReport();
            },
            () => setIsVisible(true),
        );
    };

    const onCancelClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'EditPostModalCancelClick'
        );
        close();
    };

    const onEditClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'EditPostModalEditClick'
        );
        close();
    };

    const onModalClose = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'EditPostModalCloseClick'
        );
        close();
    };

    return (
        <Modal width={300} isOpen={isVisible}
               close={onModalClose} round>
            {
                isLoading &&
                <Modal unclosable isOpen={true} width={'100%'} height={'100%'} backgroundColor={'rgba(0,0,0,0)'}>
                    <div
                        className={classNames(utilStyles.fullHeight, utilStyles.fullWidth, utilStyles.flexRow, utilStyles.justifyContentCenter, utilStyles.alignItemsCenter)}>
                        <Loading/>
                    </div>
                </Modal>
            }
            <div className={styles.editPostModalContainer}>
                {
                    isOwner ?
                        <>
                            <div
                                className={classNames(styles.editPostModalText, styles.editPostModalDeleteText)}
                                onClick={onDeleteClick}
                            >
                                <span>{t('EditPostModal.delete')}</span>
                            </div>
                            <Link href={getPostEditRoute(post.id)}>
                                <a className={styles.editPostModalText} onClick={onEditClick}>
                                    <span>{t('EditPostModal.update')}</span>
                                </a>
                            </Link>
                            <div
                                className={styles.editPostModalText}
                                onClick={onCancelClick}
                            >
                                <span>{t('EditPostModal.cancel')}</span>
                            </div>
                        </> :
                        <>
                            <div
                                className={classNames(styles.editPostModalText, styles.editPostModalDeleteText)}
                                onClick={handleReportClick}
                            >
                                <span>{t('EditPostModal.report')}</span>
                            </div>
                            <div
                                className={styles.editPostModalText}
                                onClick={onCancelClick}
                            >
                                <span>{t('EditPostModal.cancel')}</span>
                            </div>
                        </>
                }
            </div>
        </Modal>
    )
};
